import { BellIcon } from '@heroicons/react/24/solid';
import { useJobsOptional } from '../../contexts/JobsContext';
import { JobsPanel } from './JobsPanel';
import { useCompactAssistantViewport } from './DashboardAssistantChatDock/hooks/useAssistantSurfaces';
import { useDashboardRoutePanelActive } from '../../contexts/DashboardRoutePanelContext';

export default function MobileNotificationsButton() {
  const jobs = useJobsOptional();
  const isCompact = useCompactAssistantViewport();
  const isActive = useDashboardRoutePanelActive();
  if (!jobs || !isCompact || !isActive) return null;
  const count = jobs.activeCount + jobs.unreadCount + jobs.transitioningCount;
  return <JobsPanel>
    <button type="button" aria-label="Notifications" aria-haspopup="dialog" className="relative flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-ink-secondary hover:bg-paper-inset focus-visible:outline-sage lg:hidden">
      <BellIcon className="h-5 w-5" aria-hidden="true" />
      {count > 0 && <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-sage px-0.5 text-[10px] text-white">{count}</span>}
    </button>
  </JobsPanel>;
}
